module.exports = __webpack_public_path__ + "static/media/google_play_button.5c4a3b9d.png";